import React from 'react';
import PropTypes from "prop-types";
import TrackingMessage from './styles';

function MouseTrackingMessage(props) {
  const { isEnabled, pos, message } = props;
  return (
    <TrackingMessage
      enabled={isEnabled}
      position={pos}
    >
      {message}
    </TrackingMessage>
  );
}

MouseTrackingMessage.propTypes = {
  isEnabled: PropTypes.bool,
  message: PropTypes.any,
  pos: PropTypes.string
}

export default MouseTrackingMessage;
